export default __webpack_public_path__ + "38f09164abd5d884fbb4bf63485b2160.png";